import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//rxjs
import { Observable, BehaviorSubject, Subject } from 'rxjs';

import { Tables } from '../../shared/models/operations_persona';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class TableService {
  baseUrl: string = environment.dashboardUrl;

  constructor(protected http: HttpClient) {}

  // emitting data to unrelated components using behvaiour subject
  private candidateID: Subject<any> = new BehaviorSubject<any>('');
  public myObs: Subject<any> = new BehaviorSubject<any>('');

  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };

  //json data from assets as of now
  getTableData(): Observable<Tables[]> {
    const toPost = {
      roleCode: 'VLAS',
      companyHiringTypeId: parseInt(localStorage.getItem('fresherCompHiringTypeId')),
      employeeNumber: '105122',
    };
    // return this.http.get<Tables[]>(this.get_table_table_URL);
    return this.http.post<Tables[]>(this.baseUrl + 'DashboardServices/getNumberOfCandidateByUnit', toPost);
  }

  //set method for candidateID
  setCandidateID(data) {
    console.log('table service data-->', data);
    this.candidateID.next(new Date());
    this.myObs.next(data);
  }

  //get method for candidateID
  getCandidateID() {
    console.log(this.candidateID);
    return this.candidateID.asObservable();
  }
}
